export function omitUndefined(obj: { [key: string]: string | undefined }) {
  const result: { [key: string]: string | undefined } = {};
  Object.entries(obj).forEach(([ key, value ]) => {
    if (value !== undefined) {
      result[key] = value;
    }
  });
  return result;
}
